import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import SoftBadge from 'components/common/SoftBadge';
import ModalAsociarPlanFacturacion from '../../cliente/components/ModalAsociarPlanFacturacion';

/**
 * Componente para mostrar el plan de facturación asociado a un producto
 * o un botón para asociarlo si no tiene uno
 */
const PlanFacturacionAsociado = ({ product, orden, onPlanAsociado }) => {
    const [showModalAsociar, setShowModalAsociar] = useState(false);

    // Parsear el JSON del plan de facturación
    const planesFacturacion = product.vJsonPlanFacturacion 
        ? JSON.parse(product.vJsonPlanFacturacion) 
        : [];

    const tienePlanAsociado = planesFacturacion && planesFacturacion.length > 0;

    const handleAbrirModal = () => {
        setShowModalAsociar(true);
    };

    const handleCerrarModal = () => {
        setShowModalAsociar(false);
    };

    const handlePlanAsociadoExitoso = () => {
        if (onPlanAsociado) {
            onPlanAsociado();
        }
        handleCerrarModal();
    };

    return (
        <>
            <Row className="mt-2">
                <Col>
                    {tienePlanAsociado ? (
                        <div className="d-flex align-items-center gap-2">
                            <SoftBadge bg="success">Plan Asociado</SoftBadge>
                            <span className="text-muted small">
                                RFC: <strong>{planesFacturacion[0].vRfc}</strong>
                            </span>
                            {planesFacturacion[0].iCantidadTimbres && (
                                <span className="text-muted small">
                                    | Timbres: <strong>{planesFacturacion[0].iCantidadTimbres}</strong>
                                </span>
                            )}
                            {planesFacturacion[0].bIsPaid !== undefined && (
                                <SoftBadge bg={planesFacturacion[0].bIsPaid ? "info" : "warning"}>
                                    {planesFacturacion[0].bIsPaid ? "Pagado" : "Pendiente de Pago"}
                                </SoftBadge>
                            )}
                        </div>
                    ) : (
                        <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={handleAbrirModal}
                        >
                            <FontAwesomeIcon icon={faPlusCircle} className="me-1" />
                            Asociar Plan de Facturación
                        </Button>
                    )}
                </Col>
            </Row>

            <ModalAsociarPlanFacturacion
                show={showModalAsociar}
                onHide={handleCerrarModal}
                ordenSeleccionada={{ 
                    idOrdenDetalle: product.idOrdenDetalle,
                    vNombreProducto: product.vNombreProducto
                }}
                onPlanAsociado={handlePlanAsociadoExitoso}
                idCliente={orden.idClienteAkasia}
            />
        </>
    );
};

PlanFacturacionAsociado.propTypes = {
    product: PropTypes.object.isRequired,
    orden: PropTypes.object.isRequired,
    onPlanAsociado: PropTypes.func
};

export default PlanFacturacionAsociado;
